import { ChangeDetectionStrategy, Component, ElementRef, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';

// TODO: Think about splitting this into multiple parts for better readability (+ link buttons / anchor buttons)
/* eslint-disable @angular-eslint/component-selector */
@Component({
    selector: `
    button[ce-button], button[ce-button-large], button[ce-button-small], a[ce-button], a[ce-button-large], a[ce-button-small]
  `,
    standalone: true,
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule],
    templateUrl: './ce-button.component.html',
    styleUrl: './ce-button.component.scss',
    host: {
        class: 'ce-button',
    },
})
/* eslint-enable @angular-eslint/component-selector */
export class CeButtonComponent {
    // Define additional button sizes
    additionalButtonSizes: string[] = ['ce-button-large', 'ce-button-small'];
    additionalButtonTypes: string[] = ['ce-button-type-secondary', 'ce-button-type-tertiary', 'ce-button-type-quaternary', 'ce-button-icon', 'ce-button-ghost'];
    selectedButtonType = 'ce-button-default';

    constructor(elem: ElementRef) {
        // Get the native button element
        const buttonElement = elem.nativeElement as HTMLButtonElement;
        // Get the class list of the button element
        const classList = (buttonElement as HTMLButtonElement).classList;

        // Loop through the additional button sizes

        for (const buttonSize of this.additionalButtonSizes) {
            // If the button element has an attribute that matches a button size, set the selected button type to that size
            if (buttonElement.hasAttribute(buttonSize)) {
                this.selectedButtonType = buttonSize;
            }
        }

        // Add the selected button type to the class list
        classList.add(this.selectedButtonType);

        // Loop through the additional button types ('ce-button-type-secondary', 'ce-button-type-tertiary', ...)
        for (const buttonType of this.additionalButtonTypes) {
            // If the button element has an attribute that matches a button type, add that type to the class list
            if (buttonElement.hasAttribute(buttonType)) {
                classList.add(buttonType);
            }
        }
    }
}
